"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VALID_TEXT_EXTENSIONS = void 0;
exports.isValidTextFileType = isValidTextFileType;
const file_utils_1 = require("./file-utils");
exports.VALID_TEXT_EXTENSIONS = ['.txt', '.pdf'];
function isValidTextFileType(filename) {
    const name = filename.toLowerCase();
    const extension = (0, file_utils_1.getFileExtension)(name);
    return exports.VALID_TEXT_EXTENSIONS.includes(extension);
}
//# sourceMappingURL=is-valid-text-type.js.map